import React from "react";
import { useReveal } from "@/hooks/useReveal";

/**
 * Reveal — thin wrapper that fades child up on viewport entry with an optional
 * staggered delay. Uses the .tbb-rise-in keyframe from index.css.
 *
 * Props:
 *   index?: number  — column index for stagger; delay = (index % cols) * step
 *   cols?:  number  — max column count (default 4)
 *   step?:  number  — ms delay per column (default 90)
 *   as?:    ElementType — wrapper tag (default "div"; use "span" for inline flow)
 *   className, style, ...rest — passed through
 */
export default function Reveal({
  index = 0,
  cols = 4,
  step = 90,
  as: Tag = "div",
  className = "",
  style = {},
  children,
  ...rest
}) {
  const { ref, visible } = useReveal();
  const delay = (index % cols) * step;
  const combined = `${className} ${visible ? "tbb-rise-in" : ""}`.trim();
  const mergedStyle = visible
    ? { ...style, animationDelay: `${delay}ms` }
    : { ...style, opacity: 0 };
  return (
    <Tag ref={ref} className={combined} style={mergedStyle} {...rest}>
      {children}
    </Tag>
  );
}
